import { OrderLineModel, WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import { CartLineModel } from "@MasterBluePrint/Overrides/Types/ApiModels";
import React, { Component } from "react";

export function ValidateWishListLineCollection(
    cartLines: WishListLineModel[] | OrderLineModel[] | CartLineModel[] | null,
) {
    let isValid = true;
    cartLines?.forEach((line: WishListLineModel | OrderLineModel | CartLineModel, index: number) => {
        if (!ValidateMSQ(line)) {
            isValid = false;
        }
    });
    return isValid;
}
export function ValidateMSQ(cartLine: WishListLineModel | OrderLineModel | CartLineModel) {
    if (!cartLine) {
        return true;
    }
    const multipleSaleQty = cartLine?.properties?.multipleSaleQty ? Number(cartLine?.properties?.multipleSaleQty) : 0;

    if (multipleSaleQty && multipleSaleQty > 1) {
        const qtyOrdered1 = cartLine.qtyOrdered! % multipleSaleQty;

        if (qtyOrdered1 !== 0) {
            return false;
        }
    }
    return true;
};
export const ValidateMSQWithOrderedQty = (
    cartLine: WishListLineModel | OrderLineModel | CartLineModel,
    qtyOrdered: number | null,
) => {
    const multipleSaleQty = cartLine?.properties?.multipleSaleQty ? Number(cartLine?.properties?.multipleSaleQty) : 0;

    if (multipleSaleQty && multipleSaleQty > 1) {
        const qtyOrdered1 = qtyOrdered! % multipleSaleQty;

        if (qtyOrdered1 !== 0) {
            return false;
        }
    }
    return true;
};